import React, { useContext } from "react";
import SelectV2 from "../../../view/SelectV2";
import { TargetTypeContext, TargetTypes } from "./TargetTypeTab";

function TargetTypeDropdown() {

    const { targetType, setTargetType } = useContext(TargetTypeContext);

    const onChange = (value) => {
        setTargetType(value);
    }

    const options = Object.values(TargetTypes).map((value) => ({ value, label: value }));

    return (
        <>
            <label className="addrules-target-type-label-v2" htmlFor="targetType">Target Type</label>
            <SelectV2
                inputId="targetType"
                className="oct_select-v2"
                value={targetType}
                onChange={onChange}
                options={options}
            />
        </>
    )

}

export default TargetTypeDropdown;
